import { render, staticRenderFns } from "./FullInvigilation.vue?vue&type=template&id=cf470cf6"
import script from "./FullInvigilation.vue?vue&type=script&lang=js"
export * from "./FullInvigilation.vue?vue&type=script&lang=js"
import style0 from "./FullInvigilation.vue?vue&type=style&index=0&id=cf470cf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports